module.exports = __webpack_public_path__ + "static/media/clipboard_with_checklist.8f2ef7af.svg";